import BouncingSpinner from 'components/BouncingSpinner';
import Download from 'components/Icons/Download';
import OutsideClick from 'components/OutsideClick';
import React, { useState } from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import { ExportSortDirection } from 'records/Export';
import { Project } from 'records/Project';
import { SubmittalListTypes } from 'records/Submittal';
import { exportXLSXSubmittals } from 'services/submittalService';
import { getDateString } from 'utils/general';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { Button } from 'components/lib';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props extends WithAppStoreProps {
  id: string;
  listType: SubmittalListTypes;
}

const ExportButton = (props: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [downloading, setDownloading] = useState<boolean>(false);
  const { translate } = useTranslator(['submittalsPage', 'buttons']);

  const handleDownloadClick = (): void => {
    setOpen(!open);
  };

  const handleOutsideClick = (): void => {
    setOpen(false);
  };

  const handleXLSXClick = async (): Promise<void> => {
    try {
      // const { submittals } = this.props.appState;
      // const filteredPunches =
      //   queriedPunches.size !== punches.size ? queriedPunches.toArray() : [];
      const { queriedSubmittals, submittalQuery, submittals } = props.appState;

      const filteredSubmittals: string[] =
        queriedSubmittals.size !== submittals.size
          ? queriedSubmittals.toArray()
          : [];

      const sortdirection =
        submittalQuery.sortDirection === 'ascending'
          ? ExportSortDirection.ASCENDING
          : ExportSortDirection.DESCENDING;

      const result = await exportXLSXSubmittals(
        props.appState.selectedProject,
        props.listType,
        filteredSubmittals,
        submittalQuery.sortField,
        sortdirection
      );

      downloadFile(result.url, result.extension);
    } catch (err) {
      console.log('handleDownloadClick Error:', err);
    }
  };

  // handlePDFClick = async (): Promise<void> => {
  //   try {
  //     const { queriedPunches, punches } = this.props.appState;
  //     const filteredPunches =
  //       queriedPunches.size !== punches.size ? queriedPunches.toArray() : [];
  //     const { url, extension } = await exportPDFProject(
  //       this.props.appState.selectedProject,
  //       filteredPunches
  //     );
  //
  //     this.downloadFile(url, extension);
  //   } catch (err) {
  //     console.log('downloadPDFClick Error: ', err);
  //   }
  // };

  const downloadFile = async (
    url: string,
    extension: string
  ): Promise<void> => {
    try {
      setOpen(false);
      setDownloading(true);

      const { appState } = props;
      const { projects, selectedProject } = appState;
      const { name } = projects.get(selectedProject, new Project());

      const filename = `${name} ${translate(
        'submittalsPage:submittalLog'
      )} ${getDateString()}.${extension}`;

      const resp = await fetch(url);
      const blob = await resp.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = blobUrl;
      a.setAttribute('download', filename);

      const rootEl = document.getElementById('root');

      if (rootEl) {
        rootEl.appendChild(a);

        a.click();

        rootEl.removeChild(a);
      }
    } catch (err) {
      console.log('downloadFile error: ', err);
    } finally {
      setDownloading(false);
    }
  };

  const { id } = props;

  return (
    <Manager>
      <Reference>
        {({ ref }): React.ReactNode => (
          <div ref={ref} className="hs2 flex items-center">
            {downloading ? (
              <div className="flex-center mt1 mr4">
                <BouncingSpinner />
              </div>
            ) : (
              <Button
                id={`${id}-export-btn`}
                className="row items-center justify-between mr4"
                onClick={handleDownloadClick}
                size="small"
                variant="tertiary"
              >
                <div className="mr2">
                  <Download width="14px" height="12px" />
                </div>
                <div className="font-size-4">{translate('buttons:export')}</div>
              </Button>
            )}
          </div>
        )}
      </Reference>
      <Popper>
        {({ ref, style, placement }): React.ReactNode => {
          return open ? (
            <div
              ref={ref}
              className="bgd-white wrem-9 b-2"
              style={{
                ...style,
                zIndex: 2,
              }}
              data-placement={placement}
            >
              <OutsideClick onOutsideClick={handleOutsideClick}>
                <div className="column items-center color-primary-dark">
                  <div className="bb-2 w100 flex-center">
                    <div
                      className="m2 py1 cursor-pointer"
                      onClick={handleXLSXClick}
                    >
                      {translate('buttons:exportAs')} .xlsx
                    </div>
                  </div>
                </div>
              </OutsideClick>
            </div>
          ) : null;
        }}
      </Popper>
    </Manager>
  );
};

export default withAppStore<Props>(ExportButton);
